var render = function render(){var _vm=this,_c=_vm._self._c;return _c('add-edit-workload',{staticClass:"mt-6 ml-6 pr-3"})
}
var staticRenderFns = []

export { render, staticRenderFns }